import React, { useEffect, useState } from 'react'
import { Button, Layout, Modal } from 'antd'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Redirect, useLocation, withRouter } from 'react-router-dom'
import classNames from 'classnames'
// import TopBar from 'components/cleanui/layout/TopBar'
import Breadcrumbs from 'components/cleanui/layout/Breadcrumbs'
import Menu from 'components/cleanui/layout/Menu'
// import Footer from 'components/cleanui/layout/Footer'
// import Sidebar from 'components/cleanui/layout/Sidebar'
// import SupportChat from 'components/cleanui/layout/SupportChat'
import LayoutLoader, { UserLoader } from 'layouts/loader'
import userActions from 'redux/user/actions'
import subscriptionActions from 'redux/subscription/actions'
import { ReloadOutlined } from '@ant-design/icons'
import errorImage from '../../assets/images/error-404.svg'
import { shopifyWidgetEnableUrl } from '../../redux/user/selectors'
// import SocketSubscription from '../../components/core/socket'
// import useLoader from 'hooks/use-loader'

const PageError = ({ error = '', onRetry = null }) => {
  return (
    <div className="page-loader">
      <img src={errorImage} width="280px" alt="" />
      <p
        style={{
          color: 'red',
          fontSize: '22px',
          margin: '15px 0px 10px 0px',
        }}
      >
        {error}
      </p>
      {onRetry && (
        <Button onClick={onRetry} className="primary-btn" icon={<ReloadOutlined />} type="primary">
          Retry
        </Button>
      )}
    </div>
  )
}

let redirect_url

export const MainAuth = ({ children }) => {
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const user = useSelector(state => state.user)
  const isLoggedIn = !!user?.accessToken

  useEffect(() => {
    if (isLoggedIn) {
      dispatch({
        type: userActions.USER_DETAIL,
      })
      dispatch({
        type: subscriptionActions.LOAD_SUBSCRIPTION,
      })
    }
  }, [dispatch, isLoggedIn])

  const onRetry = () => {
    if (isLoggedIn) {
      dispatch({
        type: userActions.USER_DETAIL,
      })
      dispatch({
        type: subscriptionActions.LOAD_SUBSCRIPTION,
      })
    }
  }

  if (!isLoggedIn) {
    if (pathname) redirect_url = pathname
    if (search) redirect_url += search
    return <Redirect to={`/account/login${redirect_url ? `?redirect_url=${redirect_url}` : ''}`} />
  }
  if (user?.loading) return <UserLoader />
  if (user?.error) return <PageError error={user.error} onRetry={onRetry} />
  if (user?.id) {
    if (redirect_url) {
      const temp_redirect_url = redirect_url
      redirect_url = null
      return <Redirect to={temp_redirect_url} />
    }
    return children
  }
  return null
}

export const SubscribedRoute = ({ children }) => {
  const user = useSelector(state => state.user)
  const subscription = useSelector(state => state?.subscription?.data)
  const location = useLocation()

  const is_subscribed =
    (subscription?.primary_billing_method === 'Clover' && subscription?.clover.amount > 0) ||
    (subscription?.primary_billing_method === 'Stripe' && !!subscription?.stripe?.subscription) ||
    (subscription?.primary_billing_method === 'Shopify' && !!subscription?.shopify?.charge_details)
  if (is_subscribed || user.franchise || location.pathname === '/billing/overview') return children
  return <Redirect to="/billing/overview" />
}

// const UpgradeBar = () => {
//   const { should_upgrade, customer_count = 0, subscription = {} } = useSelector(
//     state => state?.user?.business ?? {},
//   )
//   if (should_upgrade) {
//     return (
//       <div
//         className="d-flex justify-content-between align-items-center p-3"
//         style={{ background: 'rgb(40 40 40 / 90%)', color: '#fff' }}
//       >
//         <div>
//           You have reached {customer_count} customers. Your plan limit is{' '}
//           {subscription?.plan?.max_customer_count ?? 0} customers.
//         </div>
//         <Button href="https://www.clover.com/appmarket/apps/9C8RNSCV54RA6" type="primary">
//           Upgrade
//         </Button>
//       </div>
//     )
//   }

//   return null
// }

const ShopifyWidgetAlert = () => {
  const url = useSelector(shopifyWidgetEnableUrl)
  const [isVisible, setVisible] = useState(false)

  if (!url) return null

  return (
    <>
      <div
        className="d-flex justify-content-between align-items-center p-3"
        style={{ background: 'rgb(40 40 40 / 90%)', color: '#fff' }}
      >
        <div>
          Please enable RewardUp customer widget in your Shopify theme editor.
          <Button type="link" onClick={() => setVisible(true)}>
            Watch Tutorial
          </Button>
        </div>
        <Button href={url} type="primary">
          Enable App
        </Button>
      </div>
      <Modal
        title="Enable Shopify Customer Widget"
        visible={isVisible}
        onCancel={() => setVisible(false)}
        okText="Enable App"
        onOk={() => {
          window.location.href = url
        }}
        width={1000}
      >
        <img
          style={{ maxWidth: '100%' }}
          alt="Shopify Customer Widget Tutorial"
          src="https://d35g7m82l7rvbb.cloudfront.net/images/tutorial/shopify-customer-widget.gif"
        />
      </Modal>
    </>
  )
}

const mapStateToProps = ({ settings, common, user }) => ({
  isContentMaxWidth: settings.isContentMaxWidth,
  isAppMaxWidth: settings.isAppMaxWidth,
  isGrayBackground: settings.isGrayBackground,
  isSquaredBorders: settings.isSquaredBorders,
  isCardShadow: settings.isCardShadow,
  isBorderless: settings.isBorderless,
  isTopbarFixed: settings.isTopbarFixed,
  isGrayTopbar: settings.isGrayTopbar,
  common,
  user,
})

const MainLayout = ({
  children,
  isContentMaxWidth,
  isAppMaxWidth,
  isGrayBackground,
  isSquaredBorders,
  isCardShadow,
  isBorderless,
  // isTopbarFixed,
  // isGrayTopbar,
  common,
  user,
}) => {
  const code = user?.business?.code

  return (
    <MainAuth>
      <SubscribedRoute>
        {code && (
          <div className={classNames({ cui__layout__grayBackground: isGrayBackground })}>
            <Layout
              className={classNames({
                cui__layout__contentMaxWidth: isContentMaxWidth,
                cui__layout__appMaxWidth: isAppMaxWidth,
                cui__layout__grayBackground: isGrayBackground,
                cui__layout__squaredBorders: isSquaredBorders,
                cui__layout__cardsShadow: isCardShadow,
                cui__layout__borderless: isBorderless,
              })}
            >
              <Menu />
              <Layout>
                {/* <UpgradeBar /> */}
                {/* <SocketSubscription /> */}
                <ShopifyWidgetAlert />
                <Breadcrumbs />
                <Layout.Content style={{ height: '100%', position: 'relative' }}>
                  <div className="cui__utils__content full-height-container">{children}</div>
                  {common.loading && <LayoutLoader />}
                </Layout.Content>
              </Layout>
            </Layout>
          </div>
        )}
      </SubscribedRoute>
    </MainAuth>
  )
}

export default withRouter(connect(mapStateToProps)(MainLayout))
